import * as angular from "angular";
import {IController} from "angular";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";

export class PlanningDraftEditRouteResourcePanelComponent implements IController {
  options?: any;
  panelRef: any;
  optionsWrapper?: { list?: any[], propertyRef: string };
  excludeIds: any;
  selectedId: any;
  optionsPrefix: string;
  route?: any;
  pickingTimeOffsetInMinutes?: any;
  routeName: string;
  routeColor: string;

  public routeNameCopy: string;
  public isEditRouteNameMode: boolean = false;
  public isEditPickingTimeMode: boolean = false;
  public routeStartTime: any;
  public startOfDay: any;
  public pickingTime: any;
  public routeColorCopy: any;

  private selectedIdCopy: any;

  constructor(private moment, private commonsConstants, private commonsDialogService: CommonsDialogService) {
  }

  $onInit() {
    if (!this.routeName) {
      this.routeName = 'Route';
    }
    if (this.route) {
      this._setPickingTime();
    }
    if(!this.routeColor) {
      this.routeColorCopy = '#FFFFFF'
    } else {
      this.routeColorCopy = angular.copy(this.routeColor);
    }
  }

  onEditRouteName() {
    this.isEditRouteNameMode = true;
    this.routeNameCopy = angular.copy(this.routeName);
  }

  onEditPickingTime() {
    this.isEditPickingTimeMode = true;
    this._setPickingTime();
  }

  onChangePickingTime(time) {
    this.pickingTime = time;
  }

  onSubmitRouteName(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.panelRef.config.onChangeRouteName(this.panelRef, this.routeNameCopy);
      }
    }
  }

  onSubmitPickingTime(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        const updatedPickingTimeOffsetInMinutes = (this.routeStartTime - this.pickingTime) / 60000;
        this.panelRef.config.onChangePickingTimeOffsetInMinutes(this.panelRef, (updatedPickingTimeOffsetInMinutes >= 0 ? updatedPickingTimeOffsetInMinutes : undefined));
      }
    }
  }

  onCancelRouteName() {
    this.isEditRouteNameMode = false;
    this.routeNameCopy = undefined;
  }

  onCancelRoutePickingTime() {
    this.isEditPickingTimeMode = false;
    this._setPickingTime();
  }

  onSelectValue(id) {
    this.selectedIdCopy = id;
    this.panelRef.config.onChangeResource(this.panelRef, this.selectedIdCopy);
  }

  onColorChange() {
    this.commonsDialogService.selectColor(this.routeColorCopy, this.commonsConstants.colorPalletRoutes)
      .then(color => {
        this.routeColorCopy = color;
        this.panelRef.config.onChangeRouteColor(this.panelRef, this.routeColorCopy);
    })
  }

  private _setPickingTime() {
    const routeStartTime = this.route?.activities?.[0]?.eta || this.route?.activities?.[0]?.notBefore;
    this.routeStartTime = routeStartTime ? this.moment(routeStartTime).valueOf() : undefined;
    this.startOfDay = this.moment(this.routeStartTime).startOf('day').valueOf()

    this.pickingTime = this.pickingTimeOffsetInMinutes ?
      (this.routeStartTime - (this.pickingTimeOffsetInMinutes * 60000)) :
      this.routeStartTime;
  }
}

angular
  .module('bringoz.admin.commons')
  .component('planningDraftEditRouteResourcePanel', {
    bindings: {
      panelRef: '<',
      options: '<?',
      optionsWrapper: '<?',
      optionIds: '<?',
      optionsPrefix: '@?',
      accountIds: '<?',
      ngPlaceholder: '<?',
      excludeIds: '<?',
      selectedId: '<?',
      route: '<?',
      pickingTimeOffsetInMinutes: '<?',
      routeName: '<?',
      routeColor: '<?'
    },
    template: require('./planning-draft-edit-route-resource-panel.html').default,
    controller: PlanningDraftEditRouteResourcePanelComponent
});
